import { parsePacketForms } from 'app/lib/forms/builder'
const PAPERWORK_LINK_TOKEN = `{{paperwork.link}}`

export const PAPERWORK_LINK_PATTERN = /\{\{\s*paperwork\.link\s*\}\}/

export const DEFAULT_PAPERWORK_EXPIRY_DAYS = 14

export const DEFAULT_PAPERWORK_MESSAGE = `Hi {{contact.firstName}}, please fill out your paperwork before your visit: ${PAPERWORK_LINK_TOKEN}`

/** Why each packet can't be sent, by packet id: no forms, or a form version that isn't published.
 *  The same rule the engine's send applies, which fails the step otherwise. */
export function packetProblems(
  packets: { id: string; formsJson: unknown }[],
  forms: { formId: string; formVersion: number; status: string }[],
): Map<string, string> {
  const published = new Set(
    forms.filter((form) => form.status === `published`).map((form) => `${form.formId}@${form.formVersion}`),
  )
  const problems = new Map<string, string>()
  for (const packet of packets) {
    const refs = parsePacketForms(packet.formsJson)
    if (refs.length === 0) problems.set(packet.id, `This packet has no forms. Add a form or choose another packet.`)
    else if (refs.some((ref) => !published.has(`${ref.formId}@${ref.formVersion}`)))
      problems.set(packet.id, `A form in this packet isn't published yet. Publish it or choose another packet.`)
  }
  return problems
}
